import * as executionElementType from "./executionElementType";

export default Object.freeze({
    [executionElementType.image]: "New Image",
    [executionElementType.video]: "New Video",
});
